exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.calendar-table table th {\n    color: inherit;\n}\n", ""]);

// exports
